/**
 * Scrolls the main content container (#adobe-fonts-content) to the top.
 *
 * This targets the actual scroll container used in the site layout,
 * which has overflow-y: auto and holds all page content below the header.
 */
export function scrollContentToTop() {
  const container = document.querySelector('#adobe-fonts-content');
  if (container) {
    container.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
